import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * shadcn convention: merge conditional class values (clsx) and resolve
 * conflicting Tailwind utilities (tailwind-merge — last one wins).
 */
export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));
